import React from 'react';

function CentralAfricanRepublic(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124167)">
        <mask
          id="mask0_800_124167"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124167)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V6H0V0Z"
            fill="#3D58DB"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 6H36V12H0V6Z"
            fill="#F7FCFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 12H36V18H0V12Z"
            fill="#73BE4A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 18H36V24H0V18Z"
            fill="#FFD018"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.09569 5.41612L2.36808 7.09783L3.23965 4.21747L1.2373 2.37749L3.94859 2.278L5.09569 -0.570251L6.24278 2.278H8.94945L6.95172 4.21747L7.95222 6.92782L5.09569 5.41612Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 0H22.5V24H13.5V0Z"
            fill="#E11C1B"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124167">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CentralAfricanRepublic;
